/* tslint:disable */
/* eslint-disable */
/**
 * Activity Feed API
 * API for managing activity feed entries including historical events, actions, and notifications.  The activity feed provides a unified timeline of events and actions for insured risks (risques assurés). It supports notifications with read/unread status tracking and badge count for UI display.  ## Entry Types - **Historique**: Historical events (e.g., mandate signed, document uploaded) - **Action**: Actionable items with due dates (e.g., pending approvals, required follow-ups)  ## Sources - **Internal**: Events generated by the platform - **External**: Events from external systems or user actions  ## Entity Links Messages can contain entity references in the format `{EntityType:Guid}` which are resolved using the `entities` array for navigation purposes. 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DocumentScopeEnum = {
    Quote: 'Devis',
    Contract: 'Contrat',
    Product: 'Produit',
    Amendment: 'Avenant',
    Receipt: 'Quittance',
    Broker: 'Courtier',
    System: 'System',
    Tenant: 'Locataire',
    Subscriber: 'Souscripteur',
    BorrowerProject: 'ProjetEmprunt'
} as const;
export type DocumentScopeEnum = typeof DocumentScopeEnum[keyof typeof DocumentScopeEnum];


export function instanceOfDocumentScopeEnum(value: any): boolean {
    for (const key in DocumentScopeEnum) {
        if (Object.prototype.hasOwnProperty.call(DocumentScopeEnum, key)) {
            if (DocumentScopeEnum[key as keyof typeof DocumentScopeEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DocumentScopeEnumFromJSON(json: any): DocumentScopeEnum {
    return DocumentScopeEnumFromJSONTyped(json, false);
}

export function DocumentScopeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentScopeEnum {
    return json as DocumentScopeEnum;
}

export function DocumentScopeEnumToJSON(value?: DocumentScopeEnum | null): any {
    return value as any;
}

export function DocumentScopeEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): DocumentScopeEnum {
    return value as DocumentScopeEnum;
}

